// Copyright (c) 2025 Goffy. This file belongs to Goffy. All Rights Reserved.

import { useRoundState } from '@/stores/roundState';

export function setCurrentRoundId(roundId: string | null) {
  useRoundState.getState().setRoundId(roundId);
}

export function getCurrentRoundId(): string | null {
  return useRoundState.getState().roundId;
}

export function setCurrentHole(hole: number | null) {
  useRoundState.getState().setHole(hole);
}

export function getCurrentHole(): number | null {
  return useRoundState.getState().hole;
}
